import { render } from "./DepositWithdrawReportDetail.vue?vue&type=template&id=44ec77da&scoped=true"
import script from "./DepositWithdrawReportDetail.vue?vue&type=script&lang=js"
export * from "./DepositWithdrawReportDetail.vue?vue&type=script&lang=js"

import "./DepositWithdrawReportDetail.vue?vue&type=style&index=0&id=44ec77da&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ec77da"]])

export default __exports__